<template>
  <div :class="$style.container">
    <BrandIconLogoIcon />
  </div>
</template>

<script setup lang="ts">
import BrandIconLogoIcon from '@components/ui/icons/BrandIconLogoIcon.vue'
</script>

<style lang="scss" module>
.container {
  @include flex-center-row();
  @include size('100%');
  position: fixed;
  inset: 0;
}

.container::before {
  content: '';
  position: absolute;
  top: calc(0px - env(safe-area-inset-top));
  left: 0;
  right: 0;
  height: calc(100% + env(safe-area-inset-top));
  background:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0) 33%,
      rgba(0, 0, 0, 0) 67%,
      rgba(0, 0, 0, 0.5) 100%
    ),
    var(--Brand-Default-Default);
  z-index: -1;
}

</style>
